<template>
	<main class="home">
		<ResourcesDetails
			:key="resourceDetails.marketingResourceId"
			:resourceDetails="resourceDetails"
		/>
		<ResourceSectionRow
			v-for="(item, index) in selectedResourceData"
			:key="index"
			:header="item.category"
			:subheader="item.description"
			:content="item.items"
			:className="item.category.replace(/\s+/g, '-').toLowerCase()"
			:rowId="index"
		/>
	</main>
</template>

<script>
import ResourcesDetails from '@/components/cards/ResourcesDetails.vue';
import ResourceSectionRow from '@/components/cards/ResourceSectionRow.vue';
import ResourceService from '@/services/toolbox/marketing-resources-service.js';

export default {
	name: 'home',
	components: {
		ResourcesDetails,
		ResourceSectionRow,
	},
	data() {
		return {
			resourceDetails: {},
			resourceRowData: [],
			resourceData: [],
			selectedResourceData: {},
		};
	},
	methods: {
		filterResources(category) {
			this.selectedResourceData = this.resourceData.filter(
				(el) => el.category === category,
			);
		},
		loadDetails() {
			const app = this;

			this.selectedResourceData = this.resourceData;

			ResourceService.getResource(this.$route.params.resourceId).then(
				(response) => {
					this.resourceDetails = response.data;
					ResourceService.getMenu().then((response) => {
						app.resourceData = response.data;
						app.filterResources(this.resourceDetails.tags[0].name);
					});
				},
			);
		},
	},
	watch: {
		$route() {
			this.loadDetails();
		},
	},
	mounted() {
		this.loadDetails();
	},
};
</script>
